// @flow

import React, { type Node } from 'react';
import { getSafeDueDate, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { PaymentInfo } from './payment-info';
import { formatDueDate } from '@tectonics/prs/boleto';

type DisplayDueDateProps = {|
  label: string,
  sublabel?: string,
  location?: string,
  redesign?: boolean,
|};

export function DisplayDueDate( {label, sublabel = null, location = null, redesign = null}: DisplayDueDateProps): Node {
  const incomingPayment = useIncomingPayment();
  if(incomingPayment.status !== 'PE')
    throw new Error(`Due date: invalid payment status ${incomingPayment.status}, it should be PE`);

  return (
    <PaymentInfo label={label} subLabel={sublabel} location={location} redesign={redesign}>
      {formatDueDate(getSafeDueDate(incomingPayment))}
    </PaymentInfo>
  );
}
